import UpdateKml from "../components/setting/kml/UpdateKml";

const UpdateKmlPage = () =>{
    return(
    <UpdateKml/>
    )
}

export default UpdateKmlPage;